import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'


# Initialize firebase
config =
    apiKey: "AIzaSyCbT98s-zxJK22_r7vcIHKDr-nYyLfQ6-c"
    authDomain: "rain-ticket.firebaseapp.com"
    databaseURL: "https://rain-ticket.firebaseio.com"
    projectId: "rain-ticket"
    storageBucket: "rain-ticket.appspot.com"
    messagingSenderId: "651322071069"
    appId: "1:651322071069:web:3b2d918eaf7d4b4b72cef4"
firebase.initializeApp config


# User (root fields must exist for Pug to not throw an error)
user = #{}
    id: ''
    email: ''
    admin: false
    details:
        address:
            country: ''
export { user }

auth = firebase.auth()
auth.onAuthStateChanged (u) ->
    console.log "Local user: ", u?.uid
    Vue.set(user, 'id', u?.uid || '')
    Vue.set(user, 'email', u?.email || '')
    Vue.set user, 'admin', (\
    u?.uid is 'tKXCZsxf8hQeF7V4oL8xp2bJKAV2' || \
    u?.uid is 'QeDgy1Lu59NEvLQXvqDhtsuioTg1' || \
    u?.uid is 'r2yAcHkHUtXLetbkL9t7BOWlACv2' || \
    u?.uid is 'SLvODfe4zzZff1B0kEEodGhLIpg2' || \
    u?.uid is 'egsCXYXbX9UCffLhyuFYGxbiEqi2') # Martina
    loadUser u if u?
loadUser = (u) ->
    u = auth.currentUser unless u?
    db = firebase.firestore()
    db.collection('users').doc(u.uid).get().then (doc) ->
        unless doc? then return
        unless doc?.exists then return
        Vue.set user, 'details', doc.data()
    .catch (e) ->
        console.log 'User eror: ', e
export { loadUser }